<template>
  <div>
    <section class="section is-main-section">
      <card-component title="User Form" icon="account" has-back>
        <form @submit.prevent="submit">
          <b-field label="User" horizontal>
            <b-input placeholder="Userame" v-model="form.username" />
          </b-field>
          <b-field horizontal>
            <b-input placeholder="Email" type="email" v-model="form.email" />
          </b-field>
          <hr />
          <b-field label="Role" horizontal>
            <b-select placeholder="Select role" v-model="form.role_id">
              <option v-for="role in roles" :value="role.id" :key="role.id">
                {{ role.name }}
              </option>
            </b-select>
          </b-field>
          <hr />
          <b-field
            v-if="hasGatewayUserPermission"
            custom-class="is-normal"
            label="Gateways"
            horizontal
          >
            <multiselect
              v-model="form.gateways"
              :options="gateways"
              multiple
              label="name"
              track-by="name"
            />
          </b-field>
          <hr />
          <b-field horizontal>
            <b-button
              type="is-primary"
              :loading="isLoading"
              native-type="submit"
              >Submit</b-button
            >
          </b-field>
        </form>
      </card-component>
      <card-component title="Change Password" icon="lock">
        <change-password-form :user-id="form.id" />
      </card-component>
    </section>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { read as readUser, update as updateUser } from '@/api/user'
import { read as readGateway } from '@/api/gateway'
import { read as readRole } from '@/api/role'

import ChangePasswordForm from '@/components/form/ChangePassword'

import Multiselect from 'vue-multiselect'

export default {
  name: 'UpdateUser',
  components: { ChangePasswordForm, Multiselect },
  data() {
    return {
      isLoading: false,
      clients: [],
      gateways: [],
      roles: [],
      form: {
        id: null,
        username: null,
        email: null,
        gateways: null,
        role_id: null,
        client_id: null
      }
    }
  },
  created() {
    if (this.$route.params.user) {
      this.form = this.$route.params.user
    } else {
      const userID = this.$route.params.id
      readUser(userID)
        .then(res => {
          this.form = res.data
        })
    }
    readGateway()
      .then(res => {
        this.gateways = res.data.gateways
      })
    readRole()
      .then(res => {
        this.roles = res.data.roles
      })
  },
  computed: {
    isSuperAdmin() {
      return this.$store.getters['auth/isSuperAdmin']
    },
    hasGatewayUserPermission() {
      return this.$store.getters['auth/hasPermission']('GATEWAY', 'PUT')
    }
  },
  methods: {
    submit() {
      this.isLoading = true

      updateUser({
        ...this.form,
        avatar: null,
        gateway_ids: this.form.gateways ? this.form.gateways.map(gateway => gateway.id) : []
      })
        .then(() => {
          this.$router.back()
        })
        .catch(err => {
          this.$buefy.toast.open({
            message: `Error: ${err.message}`,
            type: 'is-danger',
            queue: false
          })
        })
        .finally(() => { this.isLoading = false })
    }
  }
}
</script>
